import * as React from 'react';
import { SimpleCall, EPageTypes, EPlatformTypes } from '@cian/frontend-newbuilding-call-component';
import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';
import { useSelector } from 'react-redux';
import { getBuilders, getGaLabel, getNewbuildingId } from '../../selectors/newbuilding';
import { setUserOpenedPhoneInNewobject } from '../../utils/lastHopePopup';
import { Context } from '../../utils/withApplicationContext';
import { trackOpenContacts, trackShowPhone } from './tracking';

export const LastHopePopupCall = () => {
  const gaLabel = useSelector(getGaLabel);
  const builders = useSelector(getBuilders);
  const builderWithPhones = builders.find(builder => builder.phone && builder.phone.number);
  const newbuildingId = useSelector(getNewbuildingId);

  const onShowPhoneClick = React.useCallback(() => {
    trackShowPhone(gaLabel, 'Open_bannerCallnow');
    setUserOpenedPhoneInNewobject(newbuildingId);
  }, [gaLabel, newbuildingId]);

  const context = React.useContext(Context);

  const pageType = EPageTypes.NewbuildingCard;
  const platformType = EPlatformTypes.WebDesktop;
  const placeType = 'blockLastHopePopup';

  if (!builderWithPhones) {
    return null;
  }

  return (
    <SimpleCall
      builders={[builderWithPhones]}
      sellers={[]}
      onOpenContactsClick={() => trackOpenContacts(gaLabel)}
      onShowPhoneClick={onShowPhoneClick}
      openContactsStyles={{ size: 'XS' as const }}
      showPhoneStyles={{ size: 'XS' as const }}
      httpApi={/* istanbul ignore next */ context?.httpApi as IHttpApi}
      logger={/* istanbul ignore next */ context?.logger as ILogger}
      pageType={pageType}
      platformType={platformType}
      placeType={placeType}
    />
  );
};

LastHopePopupCall.displayName = 'LastHopePopupCall';
